var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#F3F3F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 35.6C21.89 35.6 20.911 36.59 20.911 37.8C20.911 39.01 21.89 40 23.1 40C24.31 40 25.3 39.01 25.3 37.8C25.3 36.59 24.31 35.6 23.1 35.6ZM16.5 18V20.2H18.7L22.66 28.549L21.175 31.244C20.999 31.552 20.9 31.915 20.9 32.3C20.9 33.51 21.89 34.5 23.1 34.5H36.3V32.3H23.562C23.408 32.3 23.287 32.179 23.287 32.025L23.32 31.893L24.31 30.1H32.505C33.33 30.1 34.056 29.649 34.43 28.967L38.368 21.828C38.456 21.674 38.5 21.487 38.5 21.3C38.5 20.695 38.005 20.2 37.4 20.2H21.131L20.097 18H16.5ZM34.1 35.6C32.89 35.6 31.911 36.59 31.911 37.8C31.911 39.01 32.89 40 34.1 40C35.31 40 36.3 39.01 36.3 37.8C36.3 36.59 35.31 35.6 34.1 35.6Z",
    fill: "#4E53A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.71051d363abe1f8121071320a83b5c3d.svg";
export { ForwardRef as ReactComponent };